/* eslint-disable max-len */
import { useState } from "react";
import { StaticDatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";
import { useTranslate } from "react-admin";
import { CustomButton } from "./CustomButton";

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

interface DateSelectorProps {
  handleDatePopoverClose: () => void;
  setParentDate?: (newDate: Dayjs) => void;
  localStorageKey?: string;
  timezone: string;
}

const DateSelector = ({
  handleDatePopoverClose,
  setParentDate,
  localStorageKey,
  timezone
}: DateSelectorProps) => {
  const translate = useTranslate();

  const storedDateStr = localStorageKey
    ? localStorage.getItem(localStorageKey)
    : null;

  let parsedDate: Dayjs | null = null;
  if (storedDateStr) {
    parsedDate = dayjs(storedDateStr).tz(timezone, true);
  }

  if (!parsedDate) {
    parsedDate = dayjs().tz(timezone);
  }

  const [value, setValue] = useState<Dayjs | null>(parsedDate);

  return (
    <div className="bg-mono-primaryLightBgColor text-[22px] font-['OptimaLTStd'] font-[500] text-mono-primaryTextColor">
      <div className="flex flex-wrap sm:flex-nowrap">
        <div>
          <StaticDatePicker
            displayStaticWrapperAs="desktop"
            openTo="day"
            value={value}
            onChange={(newValue) => {
              if (newValue) {
                // Ensure we interpret it in the correct time zone, no shift
                setValue(newValue.tz(timezone, true));
              }
            }}
            sx={{
              backgroundColor: "#FAF9F7",
              "& .Mui-selected": {
                backgroundColor: "#F8D1C0 !important",
                color: "#000000 !important"
              },
              "& .MuiPickersDay-root:hover": {
                backgroundColor: "#F6F4F1"
              }
            }}
          />
        </div>
      </div>
      <div className="flex w-full justify-end items-center gap-[8px] border-t border-[rgba(48,47,46,0.1)] p-[12px]">
        <CustomButton
          text={translate("common.cancel")}
          variant="tertiary"
          onClick={() => {
            handleDatePopoverClose();
          }}
        />
        <CustomButton
          text={translate("common.done")}
          onClick={() => {
            if (setParentDate && value) {
              setParentDate(value);

              if (localStorageKey) {
                const dateOnlyStr = value.format("YYYY-MM-DD");
                localStorage.setItem(
                  localStorageKey,
                  JSON.stringify(dateOnlyStr)
                );
              }
            }
            handleDatePopoverClose();
          }}
        />
      </div>
    </div>
  );
};

export default DateSelector;
